import React, {useEffect} from 'react';
import CryptoJS from 'crypto-js';
import SimpleModal from "../../ui/SimpleModal";
import {useNotifications} from "../../../providers/NotificationsProvider";
import ProjectShareAutocomplete from "../ProjectShareAutocomplete";
import ButtonWithLoading from "../../layout/ui/ButtonWithLoading";
import {useApi} from "../../../providers/ApiProvider";
import ProjectsRequests from "../../../requests/ProjectsRequests";
import FormTextArea from "../../layout/ui/FormTextArea";
import ProjectShareModalFeaturedCreateLink from "./ProjectShareModalFeaturedCreateLink";
import ProjectShareModalFeaturedAccountAccesses from "./ProjectShareModalFeaturedAccountAccesses";
import ProjectShareModalFeaturedSharesList from "./ProjectShareModalFeaturedManageAccess";
import ProjectShareModalFeaturedManageAccess from "./ProjectShareModalFeaturedManageAccess";

export default function ProjectShareModalFeatured({visible = false, projectId = '', onClick, onCancel, shares, onRemoveAccess}) {
    const notifications = useNotifications();
    const [lastUpdate, setLastUpdate] = React.useState(0);


    const onChange = () => {
        setLastUpdate(new Date().getTime());
    }


    return (
        <SimpleModal visible={visible} onClose={onCancel} headerTitle={"Project Sharing"} modalContentClassName="modal-lg">

            <div className="mb-4 lh-1">
                <span className="fs-2">Link to the project:</span><br/>
                <a href={window.location.origin + '/p/' + projectId}
                   className="fs-2"
                   title="This link works for any user you've granted project access to."
                >{window.location.origin + '/p/' + projectId}</a>
                <button
                    className="btn btn-sm btn-icon btn-light-primary text-primary ms-3"
                    onClick={() => {
                        navigator.clipboard.writeText(window.location.origin + '/p/' + projectId).then(() => {
                            //console.log('Text copied to clipboard');
                            notifications.notify('Link copied to clipboard', 'success');
                        })/*.catch(err => {
                            //console.error('Failed to copy text:', err);
                        })*/;
                    }}
                >
                    <i className="ti ti-copy fs-2"></i>
                </button>
            </div>

            <ProjectShareModalFeaturedCreateLink
                projectId={projectId}
                className="mb-4"
                onChange={onChange}
            />

            <ProjectShareModalFeaturedAccountAccesses
                projectId={projectId}
                className="mb-4"
                onChange={onChange}
            />

            <hr className="my-4" />

            <ProjectShareModalFeaturedManageAccess
                projectId={projectId}
                className="mb-4"
                onChange={onChange}
                lastUpdate={lastUpdate}
            />
        </SimpleModal>
    );
}
